import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Select({ error, className, children, ...rest }) {
    return (_jsx("select", { className: cn("fwfa-select", error && "is-error", className), "aria-invalid": error || undefined, ...rest, children: children }));
}
//# sourceMappingURL=Select.js.map